import { render } from "./ProductsCarousel.vue?vue&type=template&id=328509bb&scoped=true"
import script from "./ProductsCarousel.vue?vue&type=script&lang=js"
export * from "./ProductsCarousel.vue?vue&type=script&lang=js"

import "./ProductsCarousel.vue?vue&type=style&index=0&id=328509bb&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-328509bb"]])

export default __exports__